import React, { useState } from 'react'
import { useTranslation } from '../../../../../general'
import { FormattedMessage } from 'react-intl'

const sections = [
  {
    key: 'tenders',
    titleKey: 'contacts_tenders',
    content: (
      <>
        <div>
          <span className="text-custom-gray font-montserrat text-[18px]">Fax: </span>
          <span className="text-custom-gray font-montserrat text-[18px]">0344 802 044</span>
        </div>
        <div>
          <span className="text-custom-gray font-montserrat text-[18px]">Email: </span>
          <span className="text-custom-gray font-montserrat text-[18px]">
            <a href="mailto:licitatii@magazialucostica.ro" className="text-custom-gray hover:underline">
              licitatii@magazialucostica.ro
            </a>
          </span>
        </div>
      </>
    ),
  },
  {
    key: 'complaints',
    titleKey: 'contacts_complaints',
    content: (
      <>
        <div>
          <span className="text-custom-gray font-montserrat text-[18px]">Fax: </span>
          <span className="text-custom-gray font-montserrat text-[18px]">0344 802 044</span>
        </div>
        <div>
          <span className="text-custom-gray font-montserrat text-[18px]">Email: </span>
          <span className="text-custom-gray font-montserrat text-[18px]">
            <a href="mailto:reclamatii@magazialucostica.ro" className="text-custom-gray hover:underline">
              reclamatii@magazialucostica.ro
            </a>
          </span>
        </div>
      </>
    ),
  },
  {
    key: 'consulting',
    titleKey: 'contacts_consulting',
    content: (
      <>
        <div>
          <span className="text-custom-gray font-montserrat text-[18px]">Mobile: </span>
          <span className="text-custom-gray font-montserrat text-[18px]">
            <a href="tel:0371.710.071" className="text-custom-gray hover:underline">
              0371.710.071
            </a>
          </span>
        </div>
        <div>
          <span className="text-custom-gray font-montserrat text-[18px]">Form: </span>
          <span className="text-custom-gray font-montserrat text-[18px]">
            You can use the contact form by selecting the Consulting subject, and within 24 hours a Keiron Logistics SRL representative will contact you
          </span>
        </div>
      </>
    ),
  },
]

export const GeneralContactInfo = () => {
  const [open, setOpen] = useState<string | null>(null)
  const { locale } = useTranslation()

  return (
    <div className="general-contact-info my-3 md:my-10 w-full mx-auto">
      <div className="general-contact-info__container">
        <h2 className="text-[#584B53] font-montserrat text-[23px] font-bold p-4">
          Contact
        </h2>
        <h3 className="text-custom-gray font-montserrat text-[23px] font-bold leading-0 text-center mb-[48px]">
          Other contact information
        </h3>
        <div className="flex flex-col gap-0 w-full md:w-[600px] mx-auto">
          {sections.map((section) => {
            const isOpen = open === section.key
            return (
              <div
                key={section.key}
                className={`border border-contact-gray bg-contact-bg transition-all duration-200 ${isOpen ? 'shadow-contact-shadow mt-[28px] mb-[28px] pb-[40px]' : ''}`}
              >
                <button
                  className={`w-full flex items-center justify-between px-5 py-3 focus:outline-none ${isOpen ? 'font-bold text-accent-green' : 'font-bold text-custom-gray'}`}
                  onClick={() => setOpen(isOpen ? null : section.key)}
                  type="button"
                  aria-expanded={isOpen}
                >
                  <span className={`text-[20px] font-montserrat ${isOpen ? 'text-accent-green' : ''}`}>
                    <FormattedMessage id={section.titleKey} />
                  </span>
                  <span className="text-[32px] font-montserrat">{isOpen ? '-' : '+'}</span>
                </button>
                {isOpen && (
                  <div className="px-8 pt-0">
                    {section.content}
                  </div>
                )}
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
} 